import { AuthAPI } from './auth-api';
import { FilesAPI } from './files-api';
import { RunsAPI } from './runs-api';
import { useAssistantCloudStore } from './stores/assistant-cloud-store';
import { ThreadsAPI } from './threads-api';

export class AssistantCloudLocal {
  public threads: ThreadsAPI;
  public runs: RunsAPI;
  public auth: AuthAPI;
  public files: FilesAPI;
  public telemetry = { enabled: false } as const;

  constructor({ ensureKey }: { ensureKey?: (owner: string) => Promise<void> } = {}) {
    useAssistantCloudStore.setState({ ensureKey: ensureKey ?? null });
    this.threads = new ThreadsAPI();
    this.runs = new RunsAPI();
    this.auth = new AuthAPI();
    this.files = new FilesAPI();
    this.initializeStore();
  }

  private initializeStore(): void {
    if (typeof window === 'undefined') {
      return;
    }

    const { isInitialized, initialize } = useAssistantCloudStore.getState();
    if (!isInitialized) {
      initialize().catch(error => {
        console.error('Failed to initialize AssistantCloudLocal store:', error);
      });
    }
  }

  public async clear(): Promise<void> {
    const { clear } = useAssistantCloudStore.getState();
    await clear();
  }
}

export * from './types';
export { useAssistantCloudStore } from './stores/assistant-cloud-store';
export { CloudLocalRuntimeProvider } from './cloud-local-runtime-provider';
